export default{
    //参与
    involved : [
        { giftId : 'PI17' , itemName : '阿斗回馈礼' , sendNum : 1 , notice : '在阿斗赶集系列活动中，有过任意一次付费即可领取（本次也算）',type : 1,value : 0,flag : 'requite',},
        { giftId : 'PJ56' , itemName : '阿斗焕新礼' , sendNum : 1 , notice : '参与本次新版阿斗赶集任意付费即可领取',type : 2,value : 0,flag : 'newGift',}
    ],
    //本期购买
    now_reward : {
        2 : [{ giftId : 'X622' , itemName : '' , sendNum : 1 ,},],
        4 : [{ giftId : 'MS86' , itemName : '' , sendNum : 10 ,},],
        6 : [{ giftId : 'X918' , itemName : '' , sendNum : 1 ,},],
        8 : [{ giftId : 'K749' , itemName : '' , sendNum : 5 ,},],
        10 : [{ giftId : 'MY37' , itemName : '' , sendNum : 15 ,},],
        14 : [{ giftId : 'MS86' , itemName : '' , sendNum : 30 ,},],
        18 : [{ giftId : 'MD48' , itemName : '' , sendNum : 50 ,},],
        25 : [{ giftId : 'LF85' , itemName : '' , sendNum : 20 ,},],
    },
    //参与期数
    cnt : {
        1 : [{ giftId : 'HG82' , itemName : '' , sendNum : 1 ,},],
        3 : [{ giftId : 'Y634' , itemName : '' , sendNum : 1 ,},],
        5 : [{ giftId : 'D774' , itemName : '' , sendNum : 2 ,},],
        8 : [{ giftId : 'F280' , itemName : '' , sendNum : 2 ,},],
        11 : [{ giftId : 'ZK19' , itemName : '' , sendNum : 1 ,},],
        15 : [{ giftId : 'Y657' , itemName : '' , sendNum : 3 ,},],       
    },
    //累计付费
    pay : {
        10000 : [{ giftId : 'E900' , itemName : '' , sendNum : 1 ,},],
        30000 : [{ giftId : 'Y658' , itemName : '' , sendNum : 5 ,},],
        88888 : [{ giftId : 'FN84' , itemName : '' , sendNum : 1 ,},],
        138888 : [{ giftId : 'KL25' , itemName : '' , sendNum : 1 ,},],
        198888 : [{ giftId : 'KT26' , itemName : '' , sendNum : 10 ,},],
        298888 : [{ giftId : 'LF52' , itemName : '' , sendNum : 1 ,},],
        458888 : [{ giftId : 'MB34' , itemName : '' , sendNum : 1 ,},],        
    },
}